const trackedComponent = require('../TrackedComponent');

module.exports = (flex = window.flex) => {

    const TrackedComponent = trackedComponent(flex);

    const COMPONENT_PREFIX = 'Flex';
    const BASE_FIELDS = [
        // Alias id to listingId when building the object
        'tabId',
        'session.user.id:userId',
        'session.user.username:userName',
        'session.user.summary:user',
        'visitSource', // TODO
        'page', // TODO
        'app.code:appCode',
        'thirdPartyProvider', // TODO
        'userContext.currentContext.userOrg.code:userOrgCode',
        'userContext.currentContext.userOrg.summary:userOrg'
    ];

    return new TrackedComponent({ fields: BASE_FIELDS, prefix: COMPONENT_PREFIX });
}